export default __webpack_public_path__ + "static/media/ConnectorsImg.188665b9.jpg";